import { coreAxios } from "utilities/axios";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from 'react-toastify';


const BASE_URL = process.env.REACT_APP_MAIN_URL

export const AddCPU = createAsyncThunk(
  "other/AddCPU",
  async (data) => {
    const response = await coreAxios.post(`${BASE_URL}/api/cpu-create/`, data)
    return response.data
  }
); 

export const UpdateCPU = createAsyncThunk(
  "other/UpdateCPU",
  async (data) => {
    const response = await coreAxios.put(`${BASE_URL}/api/cpu-update/${data.id}/`, data)
    return response.data
  }
);

export const GetCPUList = createAsyncThunk(
  "other/GetCPUList",
  async () => {
    const {data} = await coreAxios.get(`${BASE_URL}/api/cpu-list/`)
    return data
  }
);

export const DeleteCPU = createAsyncThunk(
  "other/DeleteCPU",
  async (id) => {
    const response = await coreAxios.delete(`${BASE_URL}/api/cpu-delete/${id}/`)
    if (response.status === 226){
      toast.warning(response.data.message)
    }
    return response.status
  }
);

